/**
 * @generated SignedSource<<1f84769a0535a222cb0117f06fb6c7bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WebHookSettings_info$data = {
  readonly platform: string;
  readonly uid: string;
  readonly webhookDeliveries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"DeliveryRow_delivery">;
      };
    }>;
  };
  readonly webhookSettings: {
    readonly endpoints: ReadonlyArray<{
      readonly maskedSecretToken: string | null;
      readonly webhookURL: string;
    }>;
    readonly ownerUid: string;
  };
  readonly " $fragmentType": "WebHookSettings_info";
};
export type WebHookSettings_info$key = {
  readonly " $data"?: WebHookSettings_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"WebHookSettings_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WebHookSettings_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WebHookSettings",
      "kind": "LinkedField",
      "name": "webhookSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ownerUid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WebHookDeliveryEndpoint",
          "kind": "LinkedField",
          "name": "endpoints",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webhookURL",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maskedSecretToken",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "last",
          "value": 50
        }
      ],
      "concreteType": "OwnerWebhookDeliveriesConnection",
      "kind": "LinkedField",
      "name": "webhookDeliveries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OwnerWebHookDeliveryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WebHookDelivery",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DeliveryRow_delivery"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "webhookDeliveries(last:50)"
    }
  ],
  "type": "OwnerInfo",
  "abstractKey": null
};

(node as any).hash = "6f181092192573e7be8ae3a911a7407b";

export default node;
